import { zergApi } from "@/service/zerg";

class HolidayService {

    async getHolidays(params) {
        try {
            const data = await zergApi.post('setting/payroll/holidays/get-holidays', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async addOrUpdateHoliday(params) {
        try {
            const data = await zergApi.post('setting/payroll/holidays/create-or-update-holiday', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getHoliday(params) {
        try {
            const data = await zergApi.post('setting/payroll/holidays/get-holiday', params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new HolidayService();